import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

import { FRAGMENT_MULTI_PROMPT_TEMPLATES } from './schema';

const QUERY = gql`
  query QueryCustomerMultiPromptTemplate(
    $customerId: ID!
    $workspaceId: ID
    $customerMultiPromptTemplateId: ID
  ) {
    customerMultiPromptTemplates(
      customerId: $customerId
      workspaceId: $workspaceId
      customerMultiPromptTemplateId: $customerMultiPromptTemplateId
    ) {
      ...CustomerMultiPromptTemplates
    }
  }
  ${FRAGMENT_MULTI_PROMPT_TEMPLATES}
`;

export const queryCustomerMultiPromptTemplate = ({
  customerId,
  workspaceId,
  customerMultiPromptTemplateId,
}) =>
  executeGqlQuery({
    query: QUERY,
    variables: {
      customerId,
      workspaceId,
      customerMultiPromptTemplateId,
    },
  }).then(({ data }) => {
    return getSingleProp(data).templates;
  });
